import React from 'react';
import { Vacancies } from './Vacancies';
import { NotAuthorizedNavbar } from '../../Components/Navbars';

export const VacanciesForNotAuthorized = () => {
    return (
        <>
            <NotAuthorizedNavbar />
            <Vacancies />
        </>
    );
};